import { LootBuyerType } from '~/shared';
import farmLogo from '../../assets/images/farm_logo.svg';
import fishLogo from '../../assets/images/logo.svg';
import oreLogo from '../../assets/images/ore_logo.svg';
import woodLogo from '../../assets/images/wood_logo.svg';

export const lootBuyersLogo = {
	[LootBuyerType.FISH]: fishLogo,
	[LootBuyerType.FARM]: farmLogo,
	[LootBuyerType.WOOD]: woodLogo,
	[LootBuyerType.ORE]: oreLogo,
};
